<template>
  <div class="d-flex align-center">
    <SysInputFormatadorValor
      v-model="item.sugestao"
      ref="inputRef"
      :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
      remover-valor-irrelevante
      centralizar
      class="input-regular font-resp w-100"
      @keydown.enter="adicionarNoCarrinho()"
      @focus="$event.target.select();focado = true"
      @blur="focado = false"
      @input="e => $emit('update:model-value', e)"
    />

    <div v-show="item.item_filial === true">
      <div v-show="!LOTE_MINIMO_VALIDO">
        <ValidaLoteMinimo
          ref="loteMinimoRef"
          v-model.number="item.sugestao"
          :lote-minimo="Number(item.lote_minimo)"
          @change="adicionarNoCarrinho()"
          @forcar-sugestao="item.comprar_fora_lote_minimo = true;$emit('add-produto-carrinho', item);"
        />
      </div>

      <div v-show="!ESTOQUE_ESTETICO_VALIDO && LOTE_MINIMO_VALIDO">
        <AlertaEstoqueEstetico
          ref="alertaEstoqueEsteticoRef"
          v-model.number="item.sugestao"
          :estoque_minimo="item.estoque_minimo"
          :lote_minimo="Number(item.lote_minimo)"
          @change="forcar_estoque_estetico = true;adicionarNoCarrinho()"
        />
      </div>

      <v-btn
        v-show="LOTE_MINIMO_VALIDO && ESTOQUE_ESTETICO_VALIDO"
        :disabled="item.sugestao <= 0" icon
        @click="adicionarNoCarrinho()"
      >
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import SysInputFormatadorValor from "@/components/utils/InputFormatadorDeValor.vue";
import AlertaEstoqueEstetico from "../../SugestaoEstoqueEstetico.vue";
import ValidaLoteMinimo from '../../ValidaLoteMinimo.vue';
import {mapGetters} from "vuex";
import {
  verificarMultiploLoteMinimo
} from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/VerificaMuliploLoteMinimo";

export default {
  name: "SugestaoDeCompra",
  props: {
    item: Object,
    produto_grupo: Object,
    card_completar_compra: Boolean,
  },
  components: {
    SysInputFormatadorValor,
    AlertaEstoqueEstetico,
    ValidaLoteMinimo,
  },
  data: () => ({
    focado: false,
    forcar_estoque_estetico: false
  }),
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
    }),
    LOTE_MINIMO_VALIDO() {
      return verificarMultiploLoteMinimo(this.item.sugestao, this.item.lote_minimo);
    },
    ESTOQUE_ESTETICO_VALIDO() {
      const qtd_compra = Number(this.item.sugestao).toFixed(4);
      const estoque_minimo = Number(this.item.estoque_minimo).toFixed(4);
      const estoque = Number(this.item.estoque).toFixed(4);
      return (Number(qtd_compra) + Number(estoque)) >= Number(estoque_minimo);
    }
  },
  methods: {
    adicionarNoCarrinho() {
      if (!this.item.item_filial || this.item.sugestao <= 0) {
        return;
      }

      if (!this.LOTE_MINIMO_VALIDO) {
        this.$refs.loteMinimoRef.ativador_menu = true;
        return;
      }

      if (!this.ESTOQUE_ESTETICO_VALIDO && !this.forcar_estoque_estetico) {
        setTimeout(() => this.$refs.alertaEstoqueEsteticoRef.ativador_menu = true, 800);
        return;
      }

      this.$emit('add-produto-carrinho', this.item);
    },
    focus() {
      this.$refs.inputRef.focus()
    }
  }
}
</script>

<style scoped>

</style>
